module.exports = __webpack_public_path__ + "img/logo.bf9fa0d1.png";